import { render, staticRenderFns } from "./UserBasicForm.vue?vue&type=template&id=50a629b6&scoped=true&"
import script from "./UserBasicForm.vue?vue&type=script&lang=js&"
export * from "./UserBasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a629b6",
  null
  
)

export default component.exports